import { ApiStatus } from '../../types';
export const loanTermDefaultAEM = {
    'heading': '{heading placeholder}',
    'description': '{description placeholder}',
    'selectionLabel': '{selectionLabel placeholder}',
    'confirmButtonText': '{confirmButton placeholder}',
    'infoHeader': '{infoHeader placeholder}',
    'infoDescription': '{infoDescription placeholder}',
    'termDescription': '{loanTermsDescription placeholder}',
    'validations': {
        'errorMessage': '{errorMessage placeholder}',
    },
};
export const loanTermsDefault = {
    purchaseAmount: 100000,
    interestRate: 10.1,
    loanTerms: [
        {
            'title': '1 Year',
            'amount': 167,
        },
        {
            'title': '2 Years',
            'amount': 124,
        },
        {
            'title': '3 Years',
            'amount': 100,
        },
        {
            'title': '4 Years',
            'amount': 95,
        },
    ],
    loanTermYear: 0,
};
export type LoanTermDefaultAEM = typeof loanTermDefaultAEM;
export type LoanTermDefault = typeof loanTermsDefault;
export interface LoanTermInfo {
    title: string,
    description: string,
    amount: number,
    isSelected: boolean,
}
export interface LoanTermApiEndpoints {
    updateLoanTermApiUrl?: string;
    getLoanTermApiUrl: string;
}

export interface LoanOptionsRequest {
    applicationNumber: string,
    purchaseAmount: number,
    loanTermYear: number,
    repaymentAmount: number,
}

export interface LoanOptionsResponse {
    content: string,
    purchaseAmount: number,
    interestRate: number,
    loanTerms: LoanTermInfo[],
    loanTermYear: number
}
export interface LoanTermState {
    content: LoanTermDefaultAEM,
    loanOptions: LoanTermDefault,
    getLoanTermApiStatus: ApiStatus
    updateLoanTermApiStatus: ApiStatus
    apiEndpoints: LoanTermApiEndpoints,
    loanOptionsRequest: LoanOptionsRequest,
    contentParams?: LoanTermContentParams
}

export interface LoanTermContentParams {
    description?: string[]
    heading?: string[]
}
